import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import {EcaadminDashboardService} from '../ecaadmin-dashboard/ecaadmin-dashboard.service'

@Component({
  selector: 'app-ecasub-admin-dashboard',
  templateUrl: './ecasub-admin-dashboard.component.html',
  styleUrls: ['./ecasub-admin-dashboard.component.css']
})
export class EcasubAdminDashboardComponent implements OnInit {
  currentYear = new Date().getFullYear();
  subAdminName = '';
  assignedSessionList: any[] = [];


  constructor(
    private router: Router,
    private  adminDashboardService: EcaadminDashboardService) { }

  ngOnInit(): void {
    this.subAdminName = localStorage.getItem('name');
    this.getSessionList();
  }

  onLogout() {
    localStorage.clear();
    this.router.navigate(['/ecademic/login']);
  }

  getSessionList(){
    // console.log("DDDDDD",localStorage.getItem('userId'));
    this.adminDashboardService.SubAdminSessionList({userId:localStorage.getItem('userId')}).subscribe((data:any)=>{
      // console.log("DD",data.list);
      this.assignedSessionList = data.list;
    });
  }

  onSessionSelect(sessionId:any){

  }

}
